import RolePage from './page';
import { RouterConfig } from 'router/AppRoute';
import paths from 'helper/pathRoutes';

const routes: RouterConfig[] = [
  {
    path: paths.role,
    page: RolePage,
  },
];

export default routes;
